import { useQuery } from "@tanstack/react-query";
import { emailOutboxKeys } from "@/lib/query";

export interface EmailOutboxRow {
  id: string;
  toAddresses: string[];
  subject: string;
  templateName: string | null;
  status: string;
  attempts: number;
  lastError: string | null;
  createdAt: string;
  sentAt: string | null;
}

/** Full detail for one message, including the rendered body. */
export interface EmailOutboxDetail extends EmailOutboxRow {
  fromAddress: string;
  replyTo: string | null;
  bodyText: string | null;
  bodyHtml: string | null;
  messageId: string | null;
  deliveredAt: string | null;
}

/** Most recent transactional emails (admin-only route), newest first. */
export function useEmailOutbox(enabled = true) {
  return useQuery({
    queryKey: emailOutboxKeys.all,
    queryFn: async (): Promise<EmailOutboxRow[]> => {
      const res = await fetch("/api/admin/email/outbox?limit=50");
      if (!res.ok) throw new Error("Failed to fetch email outbox");
      const json = await res.json();
      return json.data;
    },
    enabled,
  });
}

/** Full detail for one outbox message (fetched when a row is opened). */
export function useEmailOutboxDetail(id: string | null) {
  return useQuery({
    queryKey: emailOutboxKeys.detail(id ?? "none"),
    enabled: id !== null,
    queryFn: async (): Promise<EmailOutboxDetail> => {
      const res = await fetch(`/api/admin/email/outbox/${id}`);
      if (!res.ok) throw new Error("Failed to fetch message");
      const json = await res.json();
      return json.data;
    },
  });
}
